/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import CycleDay from './cycle-day';
import CycleDayDetail from './cycle-day-detail';
import CycleDayUpdate from './cycle-day-update';
import CycleDayDeleteDialog from './cycle-day-delete-dialog';

const CycleDayRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<CycleDay />} />
    <Route path="new" element={<CycleDayUpdate />} />
    <Route path=":id">
      <Route index element={<CycleDayDetail />} />
      <Route path="edit" element={<CycleDayUpdate />} />
      <Route path="delete" element={<CycleDayDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default CycleDayRoutes;
